import { ContentRowProps } from "./ContentRow.interface";

import HomepageImportantRow from "./HomepageImportantRow";
import HomepageDefaultRow from "./HomepageDefaultRow";
import BundleContentRow from "./BundleContentRow";

export const FLAVORS = {
  HOMEPAGE_IMPORTANT: "HOMEPAGE_IMPORTANT",
  BUNDLE_ROW: "BUNDLE_ROW",
} as const;

const componentsByFlavor = {
  [FLAVORS.HOMEPAGE_IMPORTANT]: HomepageImportantRow,
  [FLAVORS.BUNDLE_ROW]: BundleContentRow,
} as const;

type Flavor = keyof typeof componentsByFlavor;

const ContentRow = (props: ContentRowProps) => {
  const { flavor, dataQaSelector = "", ...rest } = props;

  const Component = flavor
    ? componentsByFlavor[flavor as Flavor]
    : HomepageDefaultRow;

  return <Component {...rest} dataQaSelector={dataQaSelector} />;
};

ContentRow.displayName = "ContentRow";
export default ContentRow;
